import { render, staticRenderFns } from "./CommentReactionsPopup.vue?vue&type=template&id=4a9c0bb2&scoped=true&"
import script from "./CommentReactionsPopup.vue?vue&type=script&lang=js&"
export * from "./CommentReactionsPopup.vue?vue&type=script&lang=js&"
import style0 from "./CommentReactionsPopup.vue?vue&type=style&index=0&id=4a9c0bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c0bb2",
  null
  
)

export default component.exports